import { Component, OnInit } from '@angular/core';
import { HeaderVisibilityService } from './services/header-visibility.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from './store/app.state';
import { getUser } from './store/selectors/account.selector';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'new-alamat-web-v1';
  showHeader: boolean = true;

  currentRoute: string = '';

  getUserProfile$: Observable<any>;
  user: any;

  ngUnsubscribe = new Subject<void>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>
  ) {
    this.getUserProfile$ = this.store.select(getUser);
   }

  ngOnInit() {
    
  }

  removeLastSegment(url: string): string {
    const segments = url.split('/');
    segments.pop(); // Remove last segment
    return segments.join('/'); // Reconstruct the URL
  }
}
